"use client"

import Icon from "@/components/Icon"
import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/components/ui/form"
import {
  Input
} from "@/components/ui/input"
import {
  Minus as MinusIcon, Plus as PlusIcon
} from "react-feather"

export function QuantityStepperNew({
  form,
  className,
}: {
    form: any
    className?: string
}) {
  const handleIncrement = () => {
    const currentValue = form.getValues("quantity")

    form.setValue("quantity", currentValue + 1)
  }

  const handleDecrement = () => {
    const currentValue = form.getValues("quantity")

    if (currentValue > 1) {
      form.setValue("quantity", currentValue - 1)
    }
  }

  return (
    <FormField
      control={form.control}
      name='quantity'
      render={({
        field 
      }) => (
        <FormItem>
          <FormControl>
            <div
              className={`lg_h-fit lg_w-fit relative h-[42px] w-[150px] ${className}`}
            >
              <button
                onClick={handleDecrement}
                className='quantityStepper_button_decrement__soON3 quantityStepper_button__jkY6V focus_outline-none disabled_cursor-not-allowed absolute top-[1%] flex h-[98%] w-[60px] items-center justify-center bg-transparent'
                type='button'
              >
                <Icon src={MinusIcon} size={22} />
              </button>
              <Input
                className='lg_h-[60px] [&::-webkit-inner-spin-button]_appearance-none [&::-webkit-outer-spin-button]_appearance-none  h-[42px] text-center [appearance:textfield]'
                type='number'
                {...field}
              />
              <button
                className='quantityStepper_button_increment__BR7Os quantityStepper_button__jkY6V focus_outline-none disabled_cursor-not-allowed absolute right-0 top-[1%] flex h-[98%] w-[60px] items-center justify-center bg-transparent'
                onClick={handleIncrement}
                type='button'
              >
                <Icon src={PlusIcon} size={20} />
              </button>
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
